import FullWidthBarBreadcrumbs from '@/components/Breadcrumb/FullWidthBarBreadcrumbs';
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import { H3, H4 } from '@/components/Element/Heading';
import VerticalLeadFormSection from '@/components/LeadForm/VerticalLeadFormSection';
import MetaTags from '@/components/Head/MetaTags';
import DrawerLink from '@/components/Button/DrawerLink';
import Map from '@/components/Map/Map';
import StateButton from '@/components/StateButton/StateButton';
import { provinces, states } from 'data/static';
import { CanadaMap } from '@/components/Map/CanadaMap';
import FullWidthHeaderSection from '@/components/StateHeaderSection/FullWidthHeaderSection';
import Head from 'next/head';

export default function WhereWeInstallPage() {
  return (
    <article>
      <Head>
        <link
          rel="canonical"
          href="https://energypal.com/home-battery-solar-installers-near-me"
        />
      </Head>
      <MetaTags
        title="Where We Install - EnergyPal"
        description="Discover where EnergyPal offers solar panel and home battery backup installations across the USA and Canada. Check if your property is eligible today."
      />

      <FullWidthHeaderSection
        dark
        heading="Home Solar Installers Near Me:"
        subHeading="Local Installers, Tax Credits, And Rebates."
      />

      <FullWidthBarBreadcrumbs
        pages={[
          {
            name: 'Where We Install',
            href: '/home-battery-solar-installers-near-me',
          },
        ]}
      />
      <CenteredContentSection>
        <H3>EnergyPal Home Solar Coverage</H3>
        <Map />
        <p>
          EnergyPal services the USA and Canada with solar panel installation
          and home battery backup solutions. Below are our service territories
          where you can find information on local installers, tax credits, and
          rebates. To see if your property qualifies{' '}
          <DrawerLink>start here</DrawerLink>
        </p>
        <H4>Home Solar By State</H4>
        <div className="grid grid-cols-2  md:grid-cols-4 gap-4">
          {states &&
            states.map((state, index: number) => (
              <StateButton
                key={index}
                image={state.image}
                state={state.state}
                link={state.link}
              />
            ))}
        </div>
        <hr />
        <H4 className="pb-4">EnergyPal Home Solar Coverage in Canada</H4>
        <CanadaMap />
        <H4 className="pt-0 mt-0">Home Solar By Province</H4>
        <div className="grid grid-cols-2  md:grid-cols-4 gap-4">
          {provinces &&
            provinces.map((province, index: number) => (
              <StateButton
                key={index}
                image={province.image}
                state={province.state}
                link={province.link}
              />
            ))}
        </div>
        <hr />
        <p>
          <DrawerLink>Signup</DrawerLink> to see our group discounts in our
          solar service areas. Simply enter your zip code and basic information
          to get customized quotes and compare products.
        </p>
      </CenteredContentSection>
      <VerticalLeadFormSection />
    </article>
  );
}
